<mat-card>
  <mat-card-header>
    <mat-card-title>Gestión del Tipo de Envío</mat-card-title>
    <mat-card-subtitle></mat-card-subtitle>
  </mat-card-header>

  <mat-card-content>

    <mat-label *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
    <mat-label *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
    <mat-label *ngIf="!isSearching && msgError.length > 0">{{msgError}}</mat-label>

    <div *ngIf="!isSearching && item != null">

      <ng-container *ngIf="canEdit">

        <form [formGroup]="formGroup">

          <div fxLayout="row stretch" fxLayout.xs="column">

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Código*</mat-label>
                <input matInput formControlName="Codigo" (keyup.enter)="onGuardar()" maxlength="100">
                <mat-error *ngIf="!formGroup.controls['Codigo'].valid && formGroup.controls['Codigo'].touched">
                  {{ getErrorCodigo() }}
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Nombre*</mat-label>
                <input matInput formControlName="Nombre" (keyup.enter)="onGuardar()" maxlength="100">
                <mat-error *ngIf="!formGroup.controls['Nombre'].valid && formGroup.controls['Nombre'].touched">
                  {{ getErrorNombre() }}
                </mat-error>
              </mat-form-field>
            </div>

            <div fxFlex=100 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Comentario</mat-label>
                <input matInput formControlName="Comentario" (keyup.enter)="onGuardar()" maxlength="200">
                <mat-error *ngIf="!formGroup.controls['Comentario'].valid && formGroup.controls['Comentario'].touched">
                  {{ getErrorComentario() }}
                </mat-error>
              </mat-form-field>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Monto Tope Mínimo</mat-label>
                <input matInput type="number" formControlName="MontoTopeMinimo" (keyup.enter)="onGuardar()">
                <!-- <mat-error *ngIf="!formGroup.controls['MontoTopeMinimo'].valid && formGroup.controls['MontoTopeMinimo'].touched">
                  {{ getErrorMontoTopeMinimo() }}
                </mat-error> -->
              </mat-form-field>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Monto Tope Máximo</mat-label>
                <input matInput type="number" formControlName="MontoTopeMaximo" (keyup.enter)="onGuardar()">
                <!-- <mat-error *ngIf="!formGroup.controls['MontoTopeMaximo'].valid && formGroup.controls['MontoTopeMaximo'].touched">
                  {{ getErrorMontoTopeMaximo() }}
                </mat-error> -->
              </mat-form-field>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isMenuPadreSearching">Variable para Cálculo de IVA</mat-label>
                <mat-label *ngIf="isMenuPadreSearching">Cargando...</mat-label>
                <mat-select formControlName="VariableCalculoIva">
                  <mat-option *ngFor="let s of variableCalculoIvaList" [value]="s.Id">{{s.Nombre}}</mat-option>
                </mat-select>
                <mat-error *ngIf="!formGroup.controls['VariableCalculoIva'].valid && formGroup.controls['VariableCalculoIva'].touched">
                  {{ getErrorVariableCalculoIva() }}
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isMenuPadreSearching">Variable para Cálculo de IVA Excedente</mat-label>
                <mat-label *ngIf="isMenuPadreSearching">Cargando...</mat-label>
                <mat-select formControlName="VariableCalculoIvaExcedente">
                  <mat-option>Ninguno</mat-option>
                  <mat-option *ngFor="let s of variableCalculoIvaList" [value]="s.Id">{{s.Nombre}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isMenuPadreSearching">Condición de Aplicación de Impuestos</mat-label>
                <mat-label *ngIf="isMenuPadreSearching">Cargando...</mat-label>
                <mat-select formControlName="CondicionAplicacionImpuestos">
                  <mat-option *ngFor="let s of condicionAplicacionImpuestosList" [value]="s.Id">{{s.Nombre}}</mat-option>
                </mat-select>
                <mat-error *ngIf="!formGroup.controls['CondicionAplicacionImpuestos'].valid && formGroup.controls['CondicionAplicacionImpuestos'].touched">
                  {{ getErrorCondicionAplicacionImpuestos() }}
                </mat-error>
              </mat-form-field>
            </div>

          </div>

        </form>

        <div fxLayout="row stretch" fxLayout.xs="column">
          <div fxFlex=33.33 fxFlex.xs=100 class="flex-item">
            <mat-checkbox [(ngModel)]="item.Activo" (keyup.enter)="onGuardar()" color="primary">Activo</mat-checkbox> 
          </div>
        </div>

      </ng-container>

      <ng-container *ngIf="!canEdit">

        <div fxLayout="row stretch" class="zb-readonly">
    
          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Código</b>: {{item.Codigo}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Nombre</b>: {{item.Nombre}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>

          <div fxFlex=100 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Comentario</b>: {{item.Comentario}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Monto Tope Mínimo</b>: {{item.MontoTopeMinimo | number:'1.2-2'}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Monto Tope Máximo</b>: {{item.MontoTopeMaximo | number:'1.2-2'}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Variable para Cálculo de IVA</b>: {{item.VariableCalculoIvaNombre}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Variable para Cálculo de IVA Excedente</b>: {{item.VariableCalculoIvaExcedenteNombre}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>
          
          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Condición de Aplicación de Impuestos</b>: {{item.CondicionAplicacionImpuestosNombre}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Activo</b>: {{item.Activo ? 'Sí' : 'No'}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>

        </div>

      </ng-container>

    </div>

  </mat-card-content>

  <mat-card-actions style="margin-bottom: 20px;">
    <div fxLayout="row stretch" fxLayout.xs="column">
      <button mat-raised-button (click)="onGuardar()" *ngIf="canEdit" [disabled]="isProcessing()" color="primary" class="zb-button">{{isSaving ? 'Guardando...' : 'Guardar'}}</button>
      <button mat-raised-button (click)="onCancel()" color="warn" class="zb-button">{{canAdd || canEdit ? 'Cancelar' : 'Cerrar'}}</button>
      <button mat-raised-button (click)="onDelete()" *ngIf="canDelete && item != null && item.Id > 0" [disabled]="isSaving" color="accent" class="zb-button">
        {{ isDeleting ? 'Eliminando...' : 'Eliminar'  }}
      </button>
    </div>
  </mat-card-actions>

</mat-card>